import { useLocale as $18f2051aff69b9bf$export$43bb16f9c6d9e3f7 } from "./context.module.js";
import { useMemo as $l9VVR$useMemo } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $33bf17300c498528$export$a2f47a3d2973640() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = (0, $18f2051aff69b9bf$export$43bb16f9c6d9e3f7)(),
    locale = _ref.locale;
  return (0, $l9VVR$useMemo)(function () {
    return new Intl.ListFormat(locale, options);
  }, [locale, options]);
}
export { $33bf17300c498528$export$a2f47a3d2973640 as useListFormatter };